// extracted by mini-css-extract-plugin
export default {"input":"ImgUpload_input__olQYb","label":"ImgUpload_label__-Lzeo"};